"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationProvider = exports.NotificationConsumer = void 0;
exports.useNotify = useNotify;
var _react = _interopRequireWildcard(require("react"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _messageBuilder = require("./messageBuilder");
var _Notification = _interopRequireWildcard(require("../Notification/Notification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NotifyContext = /*#__PURE__*/(0, _react.createContext)({
  notification: null,
  clear: () => undefined,
  failure: () => undefined,
  success: () => undefined,
  info: () => undefined,
  queue: () => undefined,
  setDeduplicated: () => undefined
});
const NotificationProvider = _ref => {
  let {
    children,
    state,
    pathname
  } = _ref;
  const [notification, setNotification] = (0, _react.useState)(null);
  const clear = () => notification !== null && setNotification(null);
  const setDeduplicated = value => {
    if (!(0, _isEqual.default)(value, notification)) {
      setNotification(value);
    }
    return value;
  };
  (0, _react.useEffect)(() => {
    if (state !== null && state !== void 0 && state.queuedNotification) {
      setDeduplicated(state.queuedNotification);
      window.history.replaceState({}, "");
    } else {
      clear();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, pathname]);
  const helper = {
    notification,
    clear,
    queue: _messageBuilder.queue,
    failure: (title, error, message, actions) => setDeduplicated((0, _messageBuilder.failure)(title, error, message, actions)),
    info: (message, title) => setDeduplicated((0, _messageBuilder.info)(message, title)),
    success: (message, title) => setDeduplicated((0, _messageBuilder.success)(message, title)),
    setDeduplicated
  };
  return /*#__PURE__*/_react.default.createElement(NotifyContext.Provider, {
    value: helper
  }, children);
};
exports.NotificationProvider = NotificationProvider;
function useNotify() {
  return (0, _react.useContext)(NotifyContext);
}
const NotificationConsumer = () => {
  const notify = useNotify();
  const ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    var _ref$current;
    if ((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.hasAttribute("scrollIntoView")) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start"
      });
    }
  }, [notify.notification]);
  if (!notify.notification) {
    return null;
  }
  const {
    actions,
    title,
    type,
    message
  } = notify.notification;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_Notification.default, {
    title: title !== null && title !== void 0 ? title : _Notification.DefaultTitles[type],
    actions: actions,
    severity: type,
    onDismiss: notify.clear
  }, message));
};
exports.NotificationConsumer = NotificationConsumer;